import { useAppDispatch, useAppSelector } from '@verantos-dev/app-state-base';
import { FilterTypeLegacy } from '@verantos-dev/types-cohorts';

import {
  addActiveCohortBuilderItemFilter,
  deleteActiveCohortBuilderItemFilter,
} from '../cohortBuilderSlice';
import { selectActiveCohortBuilderItemUniquenessFilters } from '../selectors/cohortBuilderEditModalSelectors';

const getUniquenessFilterValue = (value: string) => {
  if (value === 'MINIMUM_BETWEEN') {
    return 'FIXED_WINDOW';
  }
  return value;
};

export const useUniquenessFilters = () => {
  const dispatch = useAppDispatch();
  const _uniquenessFilters = useAppSelector(selectActiveCohortBuilderItemUniquenessFilters) ?? [];

  const uniquenessFilters = _uniquenessFilters.map((filter) => ({
    id: filter.id,
    inputFields: filter.inputFields.map((inputField) => ({
      id: inputField.id,
      value: getUniquenessFilterValue(inputField.value || ''),
    })),
  }));

  const onAddUniquenessFilterClick = () => {
    !uniquenessFilters.length &&
      dispatch(addActiveCohortBuilderItemFilter(FilterTypeLegacy.UNIQUENESS));
  };

  const onDeleteUniquenessFilterClick = (id: string) => {
    dispatch(
      deleteActiveCohortBuilderItemFilter({
        filterId: id,
        filterType: FilterTypeLegacy.UNIQUENESS,
      })
    );
  };

  return {
    uniquenessFilters,
    onAddUniquenessFilterClick,
    onDeleteUniquenessFilterClick,
  };
};
